import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, Grid, InputLabel, TableFooter } from "@mui/material";
import { Checkbox } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../PaymentInquiry/paymentInquiry-styles.css";
import {
  searchPaymentAPI,
  inquiryAPI,
} from "./PaymentInquiryService/paymentHistoryService";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import OverwriteMomentBE from "../../util/OverwriteMomentBE";
import moment from "moment";
import { IconButton, InputAdornment } from "@material-ui/core";
import AlarmIcon from "@material-ui/icons/CalendarToday";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { CustomInputText } from "../Component/CustomInputText";
import { CSVLink } from "react-csv";
import { Select, OutlinedInput, MenuItem } from "@mui/material";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService.js";
import { fetchPaymentsStatusPaidCompass } from "../Payment/PaymentService/paymentService";
// import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";

const PaymentInquiry = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect((date) => {
    // getConvertFormat(date)
  }, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [payDate, setPayDate] = useState(null);
  const [policyNo, setPolicyNo] = useState("");
  const [rowPayment, setRowPayment] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [refNo, setRefNo] = useState("");
  const [LoadingContent, setLoadingContent] = useState(false);
  const [spinner, setSpinner] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentDate, setCurrentDate] = useState(moment());
  const [openTooltip, setOpenTooltip] = useState(false);
  const [selectedReportList, setSelectedReportList] = useState("0");
  const [dataReportList, setDataReportList] = useState([]);
  const [insuredName, setInsuredName] = useState("");
  const [dueDateStart, setDueDateStart] = useState(null);
  const [dueDateEnd, setDueDateEnd] = useState(null);
  const [payDateStart, setPayDateStart] = useState(null);
  const [payDateEnd, setPayDateEnd] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [selected, setSelected] = useState([]);

  const dataStatusList = [
    { pmdId: 1, variable1: "PAID", name: "ชำระแล้ว" },
    { pmdId: 2, variable1: "UNPAID", name: "ยังไม่ชำระ" },
    { pmdId: 3, variable1: "PENDING", name: "รอดำเนินการ" },
    { pmdId: 4, variable1: "FAILED", name: "ชำระไม่สำเร็จ" },
    { pmdId: 5, variable1: "EXPIRED", name: "หมดอายุ" },
  ];

  const dataPremiumList = [
    { pmdId: 1, variable1: "All", name: "ทั้งหมด" },
    { pmdId: 2, variable1: "PREMIUM", name: "เบี้ยประกัน" },
    { pmdId: 3, variable1: "LOAN", name: "ชำระคืนเงินกู้ตามกรมธรรม์" },
  ];

  const handleChangeStatus = (event) => {
    setSelectedStatus(event.target.value);
    console.log(event.target.value);
  };

  const handleChangePaymentType = (event) => {
    setSelectedPaymentType(event.target.value);
  };

  const handleChangeReportList = (event) => {
    setSelectedReportList(event.target.value);
  };

  const handleTooltip = () => {
    setOpenTooltip(!openTooltip);
  };

  const handleChangeCurrentDate = (e) => {
    setCurrentDate(e);
  };

  const handleDateChange = (date) => {
    getConvertFormat(date);
  };

  const getConvertFormat = (date) => {
    const momentDate = moment(date);
    const formattedDate = momentDate.format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
  };

  const handleChangePolicyNo = (e) => {
    setPolicyNo(e.target.value);
    // console.log(e.target.value);
  };

  const clear = (date) => {
    setSelectedDate(null);
    // getConvertFormat(date);
    setPolicyNo("");
    setInsuredName("");
    setDueDateStart(null);
    setDueDateEnd(null);
    setPayDateStart(null);
    setPayDateEnd(null);
    setSelectedPaymentType(null);
    setSelectedStatus(null);
    setRowPayment([]);
    searchPayment();
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    return `${day}/${month}/${year}`;
  }

  // function formatDate2(dateString) {
  //   if (!dateString) {
  //     return "";
  //   }
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = date.getFullYear(); /*+ 543*/
  //   const hour = String(date.getHours()).padStart(2, "0");
  //   const minute = String(date.getMinutes()).padStart(2, "0");
  //   return `${day}/${month}/${year} ${hour}:${minute}`;
  // }

  function formatDate2(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    date.setHours(date.getHours() + 7);
  
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); // ถ้าอยากเป็น พ.ศ. ใช้ + 543
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
  
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }

  function formatDate4(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    // date.setHours(date.getHours() + 7);
  
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); // ถ้าอยากเป็น พ.ศ. ใช้ + 543
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
  
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate3 = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  const searchPayment = async () => {
    setLoadingContent(true);
    const payload = {
      policyNo: policyNo,
      dueDateStart: formatDate3(dueDateStart),
      dueDateEnd: formatDate3(dueDateEnd),
      payDateStart: formatDate3(payDateStart),
      payDateEnd: formatDate3(payDateEnd),
      paymentType: selectedPaymentType,
      status: selectedStatus,
      insuredName: insuredName,
      paymentType: selectedPaymentType,
    };

    const result = await searchPaymentAPI(payload);
    // console.log(result);
    setTimeout(() => {
      setPage(0);
      setRowPayment(result.data);
      setLoadingContent(false);
    }, 1000);
  };

  const handleChangeFullName = (e) => {
    setInsuredName(e.target.value);
  };

  const handleDueDateStart = (date) => {
    setDueDateStart(date);
  };

  const handleDueDateEnd = (date) => {
    setDueDateEnd(date);
  };

  const handlePayDateStart = (date) => {
    setPayDateStart(date);
  };

  const handlePayDateEnd = (date) => {
    setPayDateEnd(date);
  };

  useEffect(() => {
    searchPayment();
    getStatus();
  }, []);

  const inquiry = async (refNo) => {
    setSpinner(true);
    await inquiryAPI(refNo);

    const pollInterval = 1000;
    const maxRetries = 2;
    let retries = 0;

    const pollForUpdates = async () => {
      const result2 = await searchPaymentAPI(policyNo, selectedDate);

      if (result2.data.length > 0 || retries >= maxRetries) {
        clearInterval(polling);
        setTimeout(() => {
          setRowPayment(result2.data);
          setSpinner(false);
        }, 100);
      } else {
        retries++;
      }
    };

    const polling = setInterval(pollForUpdates, pollInterval);
  };

  const handleSearchClick = () => {
    searchPayment(policyNo, selectedDate);
  };

  const generateCsvData = (data) => {
    let data_csv = [];

    data.forEach((item, index) => {
      const data_row = {
        seq: index + 1, // เริ่มจาก 1
        policyNo: `=""${item.policyNo}""`,
        paymentInsuredName: item.paymentInsuredName,
        referenceNumber: item.referenceNumber,
        cardMasking: `=""${item.cardMasking}""`,
        approvalCode: `=""${item.approvalCode}""`,
        amount:
          item.amount === 0
            ? "-"
            : new Intl.NumberFormat("th-TH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(item.amount),

        loanAmount:
          item.loanAmount === 0
            ? "-"
            : new Intl.NumberFormat("th-TH", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(item.loanAmount),
        paymentDueDate: item.paymentDueDate
          ? moment(item.paymentDueDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
        paymentActualDate: item.paymentActualDate
          ? moment(item.paymentActualDate).format("DD/MM/YYYY HH:mm:ss")
          : "-",
        paymentMethod: item.paymentMethod,
        paymentStatus: item.paymentStatus,
        sendFlag: item.sendFlag || "-",
        sendDate: item.sendDate
          ? moment(item.sendDate).add(7, "hours").format("DD/MM/YYYY HH:mm:ss")
          : "-",
      };
      data_csv.push(data_row);
    });

    return data_csv;
  };

  const data_csv = generateCsvData(rowPayment);

  const headers = [
    { label: "ลำดับที่", key: "seq" },
    { label: "กรมธรรม์เลขที่", key: "policyNo" },
    { label: "ชื่อ-นามสกุล ผอป.", key: "paymentInsuredName" },
    { label: "Reference number", key: "referenceNumber" },
    { label: "Card number", key: "cardMasking" },
    { label: "Approval Code", key: "approvalCode" },
    { label: "ค่าเบี้ยประกัน", key: "amount" },
    { label: "ชำระหนี้สิน", key: "loanAmount" },
    { label: "วันที่ครบกำหนดชำระ", key: "paymentDueDate" },
    { label: "วันที่ชำระ", key: "paymentActualDate" },
    { label: "ประเภทการชำระ", key: "paymentMethod" },
    { label: "สถานะ", key: "paymentStatus" },
    { label: "สถานะส่งเข้า Compass", key: "sendFlag" },
    { label: "วันที่ส่งเข้า Compass", key: "sendDate" },
  ];

  const generateFilename = () => {
    const currentDate = moment().format("YYYYMMDDHHmm");
    return `PAYMENT_TRANSACTION_${currentDate}.csv`;
  };

  const getStatus = async () => {
    const result = await getParameterAPI(26);
    const payload = result.payload;

    if (payload && payload.length > 0) {
      setStatusList(payload);
      setSelectedStatus("");
      console.log(payload);
    }
  };

  // const handleCheckboxClick = (referenceNumber) => {
  //   setSelected((prevSelected) =>
  //     prevSelected.includes(referenceNumber)
  //       ? prevSelected.filter((id) => id !== referenceNumber) // เอาออกถ้าเลือกซ้ำ
  //       : [...prevSelected, referenceNumber] // เพิ่มเข้าไป
  //   );
  // };

  // const handleSubmitClick = async () => {
  //   console.log("Selected Reference Numbers:", selected);
  //   const resultRef = await fetchPaymentsStatusPaidCompass(selected);
  //   console.log("Result from API:", resultRef["message"]);
  //   if (resultRef && resultRef.data && resultRef.data.length > 0) {
  //     alert("การชำระเงินสำเร็จ");
  //   } else {
  //     alert("ไม่พบข้อมูลการชำระเงิน");
  //   }
  // };

  const isNarrow = useMediaQuery("(max-width:992px)");

  const fmtAmount = (n) => {
    if (n === null || n === undefined) return "-";
    if (Number(n) === 0) return "-";
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(n));
  };

  const start = page * rowsPerPage;
  const end = start + rowsPerPage;
  const displayedRows = rowPayment.slice(start, end);

  const safe = (v) => (v === null || v === undefined || v === "" ? "-" : v);

  return (
    <div>
      <Header_Home />
      <Header title="Payment Inquiry" />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      <div className="table-page-container footer-space">
        <div className="rounded-border bg-white p-2">
          <br />
          <div id="export" className="margin-l-auto p-2 text-align-right">
            {/* <button
                style={{ fontSize: 18 }}
                onClick={handleSubmitClick}
                className="btn-fill-orange  p-2 bold ml-2"
              >
                Submit
              </button> */}
            <CSVLink
              data={data_csv}
              headers={headers}
              filename={generateFilename()}
              style={{ fontSize: 18 }}
              className="btn-fill-export  p-2 bold ml-2"
            >
              Export File
            </CSVLink>
          </div>

          <br />
          <Grid
            container
            spacing={2}
            style={{ paddingInline: "32px", marginBottom: "15px" }}
          >
            {/* แถวที่ 1 */}
            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-policyNo"
                label="กรมธรรม์เลขที่"
                placeholder="กรมธรรม์เลขที่"
                value={policyNo}
                onChange={handleChangePolicyNo}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <CustomInputText
                id="input-fullname"
                label="ชื่อ นามสกุล"
                placeholder="ชื่อ นามสกุล"
                value={insuredName}
                onChange={handleChangeFullName}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                วันที่ครบกำหนดชำระ
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={dueDateStart || null}
                  onChange={handleDueDateStart}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={dueDateEnd || null}
                  onChange={handleDueDateEnd}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            {/* แถวที่ 2 */}
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                วันที่ชำระ
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={payDateStart || null}
                  onChange={handlePayDateStart}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={payDateEnd || null}
                  onChange={handlePayDateEnd}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                ประเภทการชำระค่าเบี้ย
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={selectedPaymentType}
                onChange={handleChangePaymentType}
                displayEmpty
                fullWidth
              >
                <MenuItem key="" value="">
                  <div style={{ color: "#999" }}>ประเภทค่าเบี้ย</div>
                </MenuItem>
                {dataPremiumList?.map((value) => (
                  <MenuItem key={value.pmdId} value={value.variable1}>
                    {value.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                สถานะ
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={selectedStatus}
                onChange={handleChangeStatus}
                displayEmpty
                fullWidth
              >
                <MenuItem key="" value="">
                  <div style={{ color: "#999" }}>เลือกสถานะ</div>
                </MenuItem>
                {statusList?.map((value) => (
                  <MenuItem key={value.pmdId} value={value.code}>
                    {value.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <br />
          <div className="App">
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={handleSearchClick}
                className="btn-fill-orange  p-2 bold"
              >
                ค้นหา
              </button>
              <button onClick={clear} className="btn-fill-gray p-2 bold" style={{ marginLeft: '12px' }}>
                ล้าง
              </button>
            </section>
            <br />

            {LoadingContent ? (
              <div className="p-4">
                <div className="p-2">
                  <Skeleton className="h-70px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                </div>
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer component={Paper} className="table-no-x-scroll">
                  <Table
                    size={isNarrow ? "small" : "medium"}
                    aria-label="payment-table"
                  >
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        <TableCell align="center">ลำดับที่</TableCell>
                        <TableCell align="center">กรมธรรม์เลขที่</TableCell>
                        <TableCell align="center">ชื่อ-นามสกุล ผอป.</TableCell>
                        <TableCell align="center">Reference number</TableCell>
                        <TableCell align="center">Card Number</TableCell>
                        <TableCell align="center">Approval code</TableCell>
                        <TableCell align="right">ค่าเบี้ยประกัน</TableCell>
                        <TableCell align="right">ชำระหนี้สิน</TableCell>
                        <TableCell align="center">วันที่ครบกำหนดชำระ</TableCell>
                        <TableCell align="center">วันที่ชำระ</TableCell>
                        <TableCell align="center">ประเภทการชำระ</TableCell>
                        <TableCell className="font-new" align="center">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            สถานะ
                            <Tooltip
                              PopperProps={{
                                disablePortal: true,
                              }}
                              onClose={handleTooltip}
                              onClick={handleTooltip}
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "transparent",
                                    padding: 2,
                                  },
                                },
                              }}
                              open={openTooltip}
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener
                              title={
                                <>
                                  <List sx={style}>
                                    <ListItem sx={{ color: "orange" }}>
                                      <span>PENDING คือ รอยืนยันการชำระ</span>
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem sx={{ color: "gray" }}>
                                      <span>EXPIRED คือ หมดอายุ</span>
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem sx={{ color: "green" }}>
                                      <span>PAID คือ ชำระเงินสำเร็จ</span>
                                    </ListItem>
                                    <Divider component="li" />
                                    <ListItem sx={{ color: "red" }}>
                                      <span>FAIL คือ ชำระเงินไม่สำเร็จ</span>
                                    </ListItem>
                                    <Divider component="li" />
                                  </List>
                                </>
                              }
                              sx={{ color: "rgba(255, 94, 67, 1.0)" }}
                            >
                              <IconButton>
                                <InfoIcon
                                  sx={{ color: "rgba(255, 94, 67, 1.0)" }}
                                />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          สถานะส่งเข้า Compass
                        </TableCell>
                        <TableCell align="center">
                          วันที่ส่งเข้า Compass
                        </TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {displayedRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={15} align="center">
                            ไม่พบข้อมูล
                          </TableCell>
                        </TableRow>
                      ) : (
                        displayedRows.map((row, idx) => {
                          const seq = idx + 1 + page * rowsPerPage;
                          const isChecked = selected.includes(
                            row.referenceNumber
                          ); // ถ้าจะใช้ checkbox ต่อ
                          return (
                            <TableRow
                              key={row.id ?? row.referenceNumber ?? seq}
                            >
                              <TableCell
                                data-label="ลำดับที่"
                                className="text-center"
                              >
                                {seq}
                              </TableCell>

                              <TableCell
                                data-label="กรมธรรม์เลขที่"
                                align="center"
                                className="break-all"
                              >
                                {safe(row.policyNo)}
                              </TableCell>

                              <TableCell
                                data-label="ชื่อ-นามสกุล ผอป."
                                align="center"
                              >
                                {safe(row.paymentInsuredName)}
                              </TableCell>

                              <TableCell
                                data-label="Reference number"
                                align="center"
                                className="break-all"
                                sx={{ fontSize: 13 }}
                              >
                                {safe(row.referenceNumber)}
                              </TableCell>

                              <TableCell
                                data-label="Card Number"
                                align="center"
                                className="break-all"
                              >
                                {safe(row.cardMasking)}
                              </TableCell>

                              <TableCell
                                data-label="Approval code"
                                align="center"
                              >
                                {safe(row.approvalCode)}
                              </TableCell>

                              <TableCell
                                data-label="ยอดชำระ (บาท)"
                                align="right"
                                className="text-right"
                              >
                                {fmtAmount(row.amount)}
                              </TableCell>

                              <TableCell
                                data-label="ยอดกู้ (บาท)"
                                align="right"
                                className="text-right"
                              >
                                {fmtAmount(row.loanAmount)}
                              </TableCell>

                              <TableCell
                                data-label="วันที่ครบกำหนดชำระ"
                                align="center"
                                sx={{ fontSize: 13 }}
                              >
                                {row.paymentDueDate
                                  ? formatDate(row.paymentDueDate)
                                  : "-"}
                              </TableCell>

                              <TableCell
                                data-label="วันที่ชำระ"
                                align="center"
                                sx={{ fontSize: 14 }}
                              >
                                {row.paymentActualDate
                                  ? formatDate4(row.paymentActualDate)
                                  : "-"}
                              </TableCell>

                              <TableCell
                                data-label="ประเภทการชำระ"
                                align="center"
                              >
                                {row.paymentMethod === "card"
                                  ? "บัตรเครดิต"
                                  : "QR"}
                              </TableCell>

                              <TableCell
                                data-label="สถานะ"
                                align="center"
                                style={{
                                  color:
                                    row.paymentStatus === "PENDING"
                                      ? "orange"
                                      : row.paymentStatus === "PAID"
                                      ? "green"
                                      : row.paymentStatus === "FAIL"
                                      ? "red"
                                      : "gray",
                                }}
                              >
                                {safe(row.paymentStatus)}
                              </TableCell>

                              <TableCell
                                data-label="สถานะส่งเข้า Compass"
                                align="center"
                                sx={{ fontSize: 14 }}
                              >
                                {row.paymentStatus === "PAID" &&
                                row.sendFlag === null
                                  ? "Wait"
                                  : safe(row.sendFlag)}
                              </TableCell>

                              <TableCell
                                data-label="วันที่ส่งเข้า Compass"
                                align="center"
                                sx={{ fontSize: 14 }}
                              >
                                {row.sendDate ? formatDate2(row.sendDate) : "-"}
                              </TableCell>

                              <TableCell data-label="Action" align="center">
                                {row.paymentStatus === "PENDING" ? (
                                  <Button
                                    size="small"
                                    onClick={() => inquiry(row.referenceNumber)}
                                    sx={{
                                      backgroundColor: "rgb(255, 94, 67)",
                                      height: 25,
                                      "&:hover": {
                                        backgroundColor: "#e4e4e4",
                                        boxShadow: "none",
                                      },
                                    }}
                                    variant="contained"
                                  >
                                    Inquiry
                                  </Button>
                                ) : null}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25]}
                    component="div"
                    count={rowPayment.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => {
                      setRowsPerPage(parseInt(e.target.value, 10));
                      setPage(0);
                    }}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInquiry;
